const biomass = [
  { color: 'rgb(255,255,217)', label: 'Muy baja biomasa' },
  { color: 'rgb(237,248,177)', label: 'Baja biomasa' },
  { color: 'rgb(199,233,180)', label: 'Media-baja' },
  { color: 'rgb(127,205,187)', label: 'Media' },
  { color: 'rgb(65,182,196)', label: 'Media-alta' },
  { color: 'rgb(29,145,192)', label: 'Alta' },
  { color: 'rgb(34,94,168)', label: 'Muy alta' },
  { color: 'rgb(37,52,148)', label: 'Extremadamente alta' },
  { color: 'rgb(8,29,88)', label: 'Máxima biomasa' },
];

const landcoverWater = [
  { color: 'rgb(37, 50, 228)', label: 'Río, lago u océano (9)' },
  { color: 'rgb(147, 223, 230)', label: 'Hielo y nieve (10)' },
];

const landcover = [
  { color: 'rgb(81, 151, 153)', label: 'Humedal (1)' },
  { color: 'rgb(214, 188, 116)', label: 'Pastizal (2)' },
  { color: 'rgb(255, 239, 195)', label: 'Mosaico de agricultura y pastura (3)' },
  { color: 'rgb(255, 160, 122)', label: 'Arena, Playa y Duna (4)' },
  { color: 'rgb(212, 39, 30)', label: 'Infraestructura (5)' },
  { color: 'rgb(219, 77, 79)', label: 'Otra área sin vegetación (6)' },
  { color: 'rgb(255, 170, 95)', label: 'Afloramiento Rocoso (7)' },
  { color: 'rgb(31, 141, 73)', label: 'Bosque (8)' },
  { color: 'rgb(37, 50, 228)', label: 'Río, lago u océano (9)' },
  { color: 'rgb(147, 223, 230)', label: 'Hielo y nieve (10)' },
  { color: 'rgb(250, 230, 160)', label: 'Salar (11)' },
  { color: 'rgb(168, 147, 88)', label: 'Matorral (12)' },
  { color: 'rgb(122, 89, 0)', label: 'Plantación forestal (13)' },
];

const conversionAreas = [
  { color: 'rgb(255, 239, 195)', label: 'Agricultura' },
  { color: 'rgb(255, 160, 122)', label: 'Arena, Playa y Duna' },
  { color: 'rgb(212, 39, 30)', label: 'Infraestructura' },
  { color: 'rgb(122, 89, 0)', label: 'Plantación forestal' },
];

const ndvi = [
  { color: 'rgb(165,0,38)' },
  { color: 'rgb(166,1,38)' },
  { color: 'rgb(168,3,38)' },
  { color: 'rgb(170,5,38)' },
  { color: 'rgb(172,7,38)' },
  { color: 'rgb(174,9,38)' },
  { color: 'rgb(176,11,38)' },
  { color: 'rgb(178,13,38)' },
  { color: 'rgb(180,15,38)' },
  { color: 'rgb(182,16,38)' },
  { color: 'rgb(184,18,38)' },
  { color: 'rgb(186,20,38)' },
  { color: 'rgb(188,22,38)' },
  { color: 'rgb(190,24,38)' },
  { color: 'rgb(192,26,38)' },
  { color: 'rgb(194,28,38)' },
  { color: 'rgb(196,30,38)' },
  { color: 'rgb(198,32,38)' },
  { color: 'rgb(200,33,38)' },
  { color: 'rgb(202,35,38)' },
  { color: 'rgb(204,37,38)' },
  { color: 'rgb(206,39,38)' },
  { color: 'rgb(208,41,38)' },
  { color: 'rgb(210,43,38)' },
  { color: 'rgb(212,45,38)' },
  { color: 'rgb(214,47,38)' },
  { color: 'rgb(215,49,39)' },
  { color: 'rgb(216,51,40)' },
  { color: 'rgb(217,53,41)' },
  { color: 'rgb(218,56,42)' },
  { color: 'rgb(220,58,43)' },
  { color: 'rgb(221,61,45)' },
  { color: 'rgb(222,63,46)' },
  { color: 'rgb(223,65,47)' },
  { color: 'rgb(224,68,48)' },
  { color: 'rgb(225,70,49)' },
  { color: 'rgb(226,73,50)' },
  { color: 'rgb(228,75,51)' },
  { color: 'rgb(229,77,52)' },
  { color: 'rgb(230,80,53)' },
  { color: 'rgb(231,82,54)' },
  { color: 'rgb(232,85,56)' },
  { color: 'rgb(233,87,57)' },
  { color: 'rgb(234,89,58)' },
  { color: 'rgb(236,92,59)' },
  { color: 'rgb(237,94,60)' },
  { color: 'rgb(238,97,61)' },
  { color: 'rgb(239,99,62)' },
  { color: 'rgb(240,101,63)' },
  { color: 'rgb(241,104,64)' },
  { color: 'rgb(242,106,65)' },
  { color: 'rgb(244,109,67)' },
  { color: 'rgb(244,111,68)' },
  { color: 'rgb(244,114,69)' },
  { color: 'rgb(245,116,70)' },
  { color: 'rgb(245,119,71)' },
  { color: 'rgb(245,121,72)' },
  { color: 'rgb(246,124,74)' },
  { color: 'rgb(246,126,75)' },
  { color: 'rgb(246,129,76)' },
  { color: 'rgb(247,131,77)' },
  { color: 'rgb(247,134,78)' },
  { color: 'rgb(247,137,79)' },
  { color: 'rgb(248,139,81)' },
  { color: 'rgb(248,142,82)' },
  { color: 'rgb(248,144,83)' },
  { color: 'rgb(249,147,84)' },
  { color: 'rgb(249,149,85)' },
  { color: 'rgb(250,152,86)' },
  { color: 'rgb(250,154,88)' },
  { color: 'rgb(250,157,89)' },
  { color: 'rgb(251,159,90)' },
  { color: 'rgb(251,162,91)' },
  { color: 'rgb(251,165,92)' },
  { color: 'rgb(252,167,94)' },
  { color: 'rgb(252,170,95)' },
  { color: 'rgb(252,172,96)' },
  { color: 'rgb(253,174,97)' },
  { color: 'rgb(253,176,99)' },
  { color: 'rgb(253,178,101)' },
  { color: 'rgb(253,180,102)' },
  { color: 'rgb(253,182,104)' },
  { color: 'rgb(253,184,106)' },
  { color: 'rgb(253,186,107)' },
  { color: 'rgb(253,188,109)' },
  { color: 'rgb(253,190,110)' },
  { color: 'rgb(253,192,112)' },
  { color: 'rgb(253,194,114)' },
  { color: 'rgb(253,196,115)' },
  { color: 'rgb(253,198,117)' },
  { color: 'rgb(253,200,119)' },
  { color: 'rgb(253,202,120)' },
  { color: 'rgb(253,204,122)' },
  { color: 'rgb(253,206,124)' },
  { color: 'rgb(253,208,125)' },
  { color: 'rgb(253,210,127)' },
  { color: 'rgb(253,212,129)' },
  { color: 'rgb(253,214,130)' },
  { color: 'rgb(253,216,132)' },
  { color: 'rgb(253,218,134)' },
  { color: 'rgb(253,220,135)' },
  { color: 'rgb(253,222,137)' },
  { color: 'rgb(254,224,139)' },
  { color: 'rgb(254,225,141)' },
  { color: 'rgb(254,226,143)' },
  { color: 'rgb(254,227,145)' },
  { color: 'rgb(254,228,147)' },
  { color: 'rgb(254,230,149)' },
  { color: 'rgb(254,231,151)' },
  { color: 'rgb(254,232,153)' },
  { color: 'rgb(254,233,155)' },
  { color: 'rgb(254,234,157)' },
  { color: 'rgb(254,236,159)' },
  { color: 'rgb(254,237,161)' },
  { color: 'rgb(254,238,163)' },
  { color: 'rgb(254,239,165)' },
  { color: 'rgb(254,241,167)' },
  { color: 'rgb(254,242,169)' },
  { color: 'rgb(254,243,171)' },
  { color: 'rgb(254,244,173)' },
  { color: 'rgb(254,245,175)' },
  { color: 'rgb(254,247,177)' },
  { color: 'rgb(254,248,179)' },
  { color: 'rgb(254,249,181)' },
  { color: 'rgb(254,250,183)' },
  { color: 'rgb(254,251,185)' },
  { color: 'rgb(254,253,187)' },
  { color: 'rgb(254,254,189)' },
  { color: 'rgb(254,254,189)' },
  { color: 'rgb(252,254,187)' },
  { color: 'rgb(251,253,185)' },
  { color: 'rgb(249,252,183)' },
  { color: 'rgb(248,252,181)' },
  { color: 'rgb(246,251,179)' },
  { color: 'rgb(245,250,177)' },
  { color: 'rgb(243,250,175)' },
  { color: 'rgb(242,249,173)' },
  { color: 'rgb(240,249,171)' },
  { color: 'rgb(239,248,169)' },
  { color: 'rgb(237,247,167)' },
  { color: 'rgb(236,247,165)' },
  { color: 'rgb(234,246,163)' },
  { color: 'rgb(233,245,161)' },
  { color: 'rgb(231,245,159)' },
  { color: 'rgb(230,244,157)' },
  { color: 'rgb(228,244,155)' },
  { color: 'rgb(227,243,153)' },
  { color: 'rgb(225,242,151)' },
  { color: 'rgb(224,242,149)' },
  { color: 'rgb(222,241,147)' },
  { color: 'rgb(221,240,145)' },
  { color: 'rgb(219,240,143)' },
  { color: 'rgb(218,239,141)' },
  { color: 'rgb(217,239,139)' },
  { color: 'rgb(215,238,137)' },
  { color: 'rgb(213,237,136)' },
  { color: 'rgb(211,236,135)' },
  { color: 'rgb(209,235,133)' },
  { color: 'rgb(207,234,132)' },
  { color: 'rgb(205,233,131)' },
  { color: 'rgb(203,232,129)' },
  { color: 'rgb(201,232,128)' },
  { color: 'rgb(199,231,127)' },
  { color: 'rgb(197,230,126)' },
  { color: 'rgb(195,229,124)' },
  { color: 'rgb(193,228,123)' },
  { color: 'rgb(191,227,122)' },
  { color: 'rgb(189,226,120)' },
  { color: 'rgb(187,226,119)' },
  { color: 'rgb(185,225,118)' },
  { color: 'rgb(183,224,117)' },
  { color: 'rgb(181,223,115)' },
  { color: 'rgb(179,222,114)' },
  { color: 'rgb(177,221,113)' },
  { color: 'rgb(175,220,111)' },
  { color: 'rgb(173,220,110)' },
  { color: 'rgb(171,219,109)' },
  { color: 'rgb(169,218,107)' },
  { color: 'rgb(167,217,106)' },
  { color: 'rgb(164,216,105)' },
  { color: 'rgb(162,215,105)' },
  { color: 'rgb(159,214,105)' },
  { color: 'rgb(157,213,105)' },
  { color: 'rgb(154,212,104)' },
  { color: 'rgb(152,210,104)' },
  { color: 'rgb(149,209,104)' },
  { color: 'rgb(147,208,103)' },
  { color: 'rgb(144,207,103)' },
  { color: 'rgb(142,206,103)' },
  { color: 'rgb(139,205,103)' },
  { color: 'rgb(137,204,102)' },
  { color: 'rgb(134,203,102)' },
  { color: 'rgb(132,202,102)' },
  { color: 'rgb(129,201,102)' },
  { color: 'rgb(127,199,101)' },
  { color: 'rgb(124,198,101)' },
  { color: 'rgb(122,197,101)' },
  { color: 'rgb(119,196,100)' },
  { color: 'rgb(117,195,100)' },
  { color: 'rgb(114,194,100)' },
  { color: 'rgb(112,193,100)' },
  { color: 'rgb(109,192,99)' },
  { color: 'rgb(107,191,99)' },
  { color: 'rgb(104,190,99)' },
  { color: 'rgb(102,189,99)' },
  { color: 'rgb(99,187,98)' },
  { color: 'rgb(96,186,97)' },
  { color: 'rgb(93,184,96)' },
  { color: 'rgb(90,183,96)' },
  { color: 'rgb(87,181,95)' },
  { color: 'rgb(84,180,94)' },
  { color: 'rgb(81,178,93)' },
  { color: 'rgb(78,177,93)' },
  { color: 'rgb(75,175,92)' },
  { color: 'rgb(72,174,91)' },
  { color: 'rgb(69,173,90)' },
  { color: 'rgb(66,171,90)' },
  { color: 'rgb(63,170,89)' },
  { color: 'rgb(60,168,88)' },
  { color: 'rgb(57,167,87)' },
  { color: 'rgb(54,165,87)' },
  { color: 'rgb(51,164,86)' },
  { color: 'rgb(48,162,85)' },
  { color: 'rgb(45,161,84)' },
  { color: 'rgb(42,159,84)' },
  { color: 'rgb(39,158,83)' },
  { color: 'rgb(36,157,82)' },
  { color: 'rgb(33,155,81)' },
  { color: 'rgb(30,154,81)' },
  { color: 'rgb(27,152,80)' },
  { color: 'rgb(25,151,79)' },
  { color: 'rgb(24,149,78)' },
  { color: 'rgb(23,147,77)' },
  { color: 'rgb(22,145,76)' },
  { color: 'rgb(21,143,75)' },
  { color: 'rgb(20,141,74)' },
  { color: 'rgb(19,139,73)' },
  { color: 'rgb(18,137,72)' },
  { color: 'rgb(17,136,71)' },
  { color: 'rgb(16,134,70)' },
  { color: 'rgb(15,132,69)' },
  { color: 'rgb(14,130,68)' },
  { color: 'rgb(13,128,67)' },
  { color: 'rgb(12,126,66)' },
  { color: 'rgb(11,124,65)' },
  { color: 'rgb(10,122,64)' },
  { color: 'rgb(9,120,63)' },
  { color: 'rgb(8,119,62)' },
  { color: 'rgb(7,117,61)' },
  { color: 'rgb(6,115,60)' },
  { color: 'rgb(5,113,59)' },
  { color: 'rgb(4,111,58)' },
  { color: 'rgb(3,109,57)' },
  { color: 'rgb(2,107,56)' },
  { color: 'rgb(1,105,55)' },
  { color: 'rgb(0,104,55)' },
];

const ndwi = [
  { color: '#f7fcf0' }, // blanco verdoso (muy seco)
  { color: '#e0f3db' }, // verde muy claro
  { color: '#ccebc5' }, // verde claro
  { color: '#a8ddb5' }, // verde agua
  { color: '#7bccc4' }, // celeste verdoso
  { color: '#4eb3d3' }, // celeste
  { color: '#2b8cbe' }, // azul claro
  { color: '#08589e' }, // azul intenso (agua)
];

const eii = [
  { color: '#f7fcf0' }, // blanco verdoso (muy seco)
  { color: '#e0f3db' }, // verde muy claro
  { color: '#ccebc5' }, // verde claro
  { color: '#a8ddb5' }, // verde agua
  { color: '#7bccc4' }, // celeste verdoso
  { color: '#4eb3d3' }, // celeste
  { color: '#2b8cbe' }, // azul claro
  { color: '#08589e' }, // azul intenso (agua)
];

const msa = [
  { color: '#f7fcf0' }, // blanco verdoso (muy seco)
  { color: '#e0f3db' }, // verde muy claro
];

const gpp = [
  { color: 'rgb(84,48,5)' },
  { color: 'rgb(140,81,10)' },
  { color: 'rgb(191,129,45)' },
  { color: 'rgb(223,194,125)' },
  { color: 'rgb(246,232,195)' },
  { color: 'rgb(245,245,245)' },
  { color: 'rgb(199,234,229)' },
  { color: 'rgb(128,205,193)' },
  { color: 'rgb(53,151,143)' },
  { color: 'rgb(1,102,94)' },
  { color: 'rgb(0,60,48)' },
];

const patches = [
  { color: 'rgb(64, 64, 64)', label: 'Borde (cualquier ecosistema)' }, // gris oscuro
  { color: 'rgb(0, 119, 187)', label: 'Núcleo humedal' }, // azul intenso
  { color: 'rgb(102, 204, 0)', label: 'Núcleo praderas' }, // verde lima brillante
  { color: 'rgb(0, 102, 51)', label: 'Núcleo bosques' }, // verde bosque oscuro
  { color: 'rgb(230, 230, 250)', label: 'Núcleo nieves y glaciares' }, // lavanda muy claro
  { color: 'rgb(139, 69, 19)', label: 'Núcleo matorral' }, // marrón saddlebrown
];

const eiiReclass = [
  { color: 'rgb(255,215,0)', label: 'Muy Baja (1)' },
  { color: 'rgb(50,205,50)', label: 'Baja (2)' },
  { color: 'rgb(0,128,0)', label: 'Media (3)' },
  { color: 'rgb(220,20,60)', label: 'Alto (4)' },
  { color: 'rgb(255,140,0)', label: 'Muy Alto (5)' },
];

const naturalVegetationProportion = [
  { color: 'rgb(31, 141, 73)', label: 'Vegetación Natural (1)' },
  { color: 'rgb(192, 204, 196)', label: 'Otros (2)' },
];

const ndmi = [
  { color: 'rgb(165,0,38)' },
  { color: 'rgb(215,48,39)' },
  { color: 'rgb(244,109,67)' },
  { color: 'rgb(253,174,97)' },
  { color: 'rgb(254,224,144)' },
  { color: 'rgb(255,255,191)' },
  { color: 'rgb(224,243,248)' },
  { color: 'rgb(171,217,233)' },
  { color: 'rgb(116,173,209)' },
  { color: 'rgb(69,117,180)' },
  { color: 'rgb(49,54,149)' },
];

const albedo = [
  { color: 'rgb(68,1,84)' }, // morado oscuro (albedo bajo)
  { color: 'rgb(72,40,120)' }, // morado
  { color: 'rgb(62,74,137)' }, // azul morado
  { color: 'rgb(49,104,142)' }, // azul
  { color: 'rgb(38,130,142)' }, // azul verdoso
  { color: 'rgb(31,158,137)' }, // verde azulado
  { color: 'rgb(53,183,121)' }, // verde
  { color: 'rgb(109,205,89)' }, // verde claro
  { color: 'rgb(180,222,44)' }, // amarillo verdoso
  { color: 'rgb(253,231,37)' }, // amarillo (albedo alto)
];

const ndti = ndmi;


export default {
  biomass,
  landcover,
  ndvi,
  ndwi,
  eii,
  msa,
  patches,
  conversionAreas,
  gpp,
  eiiReclass,
  naturalVegetationProportion,
  ndmi,
  albedo,
  ndti,
  landcoverWater,
};
